module.exports = __webpack_public_path__ + "img/polen.b39db84c.png";